import { render, staticRenderFns } from "./TripsUpdate.vue?vue&type=template&id=5651f87f&scoped=true"
import script from "./TripsUpdate.vue?vue&type=script&lang=js"
export * from "./TripsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651f87f",
  null
  
)

export default component.exports